import styled from 'styled-components';
import {GlobalColors, GlobalFonts} from '../../globals';

export const ContFAQSection = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 80px 0 140px 0;
  background: #F5F5F5;

  @media(min-width: 300px) and (max-width: 767px){
    padding: 60px 0;
  }
`;

export const TitleFAQ = styled.h2`
  font-family: ${GlobalFonts.fontBold};
  font-size: 48px;
  line-height: 56px;
  text-align: center;
  color: ${GlobalColors.colorPrimaryDark};
  margin-bottom: 60px;

  @media(min-width: 300px) and (max-width: 767px){
    font-size: 32px;
    line-height: 40px;
    margin-bottom: 40px;
  }
`;

export const FAQList = styled.div`
  width: 85%;
  max-width: 1440px;
  display: flex;
  flex-direction: column;
  @media(min-width: 300px) and (max-width: 767px){
    width: 90%;
  }
`;

export const FAQItem = styled.div`
  background: #FFFFFF;
  border: 1px solid ${props => props.isOpen ? GlobalColors.colorPrimary : '#E0E0E0'};
  overflow: hidden;
  transition: all 0.3s ease;
`;

export const FAQQuestion = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 25px 30px;
  cursor: pointer;
  background: ${props => props.isOpen ? GlobalColors.colorPrimary : '#FFFFFF'};
  transition: all 0.3s ease;

  &:hover {
    background: ${props => props.isOpen ? GlobalColors.colorPrimary : '#F9F9F9'};
  }

  @media(min-width: 300px) and (max-width: 767px){
    padding: 20px;
  }
`;

export const QuestionText = styled.h3`
  font-family: ${GlobalFonts.fontBold};
  font-size: 20px;
  line-height: 28px;
  color: ${props => props.isOpen ? '#FFFFFF' : GlobalColors.colorText};
  margin: 0;
  flex: 1;
  padding-right: 20px;
  transition: color 0.3s ease;

  @media(min-width: 300px) and (max-width: 767px){
    font-size: 16px;
    line-height: 24px;
  }
`;

export const IconButton = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: ${props => props.isOpen ? '#FFFFFF' : GlobalColors.colorPrimary};
  color: ${props => props.isOpen ? GlobalColors.colorPrimary : '#FFFFFF'};
  flex-shrink: 0;
  transition: all 0.3s ease;
  transform: ${props => props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};

  svg {
    width: 20px;
    height: 20px;
    color: inherit;
    fill: none;
    stroke: currentColor;
  }

  @media(min-width: 300px) and (max-width: 767px){
    width: 28px;
    height: 28px;

    svg {
      width: 18px;
      height: 18px;
    }
  }
`;

export const FAQAnswer = styled.div`
  max-height: ${props => props.isOpen ? '500px' : '0'};
  opacity: ${props => props.isOpen ? '1' : '0'};
  overflow: hidden;
  transition: max-height 0.3s ease, opacity 0.3s ease, padding 0.3s ease;
  padding: ${props => props.isOpen ? '25px 30px' : '0 30px'};

  @media(min-width: 300px) and (max-width: 767px){
    padding: ${props => props.isOpen ? '20px' : '0 20px'};
  }
`;

export const AnswerText = styled.p`
  font-family: ${GlobalFonts.fontRegular};
  font-size: 16px;
  line-height: 24px;
  color: ${GlobalColors.colorText};
  margin: 0;

  @media(min-width: 300px) and (max-width: 767px){
    font-size: 14px;
    line-height: 22px;
  }
`;
